<template>
  <div class="animated fadeIn" style="overflow-y:hidden">

    <div class="row">
      <div class="col">
        <b-button @click="filterModalShow = !filterModalShow" :disabled="showLoadingAnimation">Filter</b-button>
        <span> By </span>
        <span v-if="filterObject.campaignDocId.length > 0">[Campaign id]: {{filterObject.campaignDocId}} </span>
        <span v-if="filterObject.claimEmail.length > 0">and [Email]: {{filterObject.claimEmail}} </span>
        <span v-if="filterObject.prizeMoney.length > 0">and [prize money]: {{filterObject.prizeMoney}} </span>
        <span v-if="filterObject.status.length > 0">and [status]: {{filterObject.status}} </span>
        <span v-if="filterObject.requestedTaxInvoice.length > 0">and [tax invoice]: {{filterObject.requestedTaxInvoice}} </span>
        <b-button @click="clearFilters()" :disabled="showLoadingAnimation">Clear Filters</b-button>
      </div>
    </div>

    <!-- Filter Modal Component -->
    <b-modal id="modal1" title="Filter" v-model="filterModalShow">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><label for="campaignName">Campaign id:</label></b-col>
        <b-col><input type="text" id="campaignName" placeholder="" v-model="filterObject.campaignDocId"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="email">Email:</label></b-col>
        <b-col><input type="text" id="email" placeholder="" v-model="filterObject.claimEmail"></b-col>
      </b-row>
      <!-- <b-row>
        <b-col><label for="hoyaAccount">HOYA account Number:</label></b-col>
        <b-col><input type="text" id="hoyaAccount" placeholder="" v-model="filterObject.hoyaAccountNumber"></b-col>
      </b-row> -->
      <b-row>
        <b-col><label for="prizeMoney">Prize Money:</label></b-col>
        <b-col><input type="text" id="prizeMoney" placeholder="" v-model="filterObject.prizeMoney"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="status">Status:</label></b-col>
        <b-col>
          <!-- <input type="text" id="status" placeholder="" v-model="filterObject.status"> -->
          <b-dropdown id="ddown3" :text="filterObject.status" class="m-md-1">
          <b-dropdown-item href="#" @click="searchStatusSelected('')"></b-dropdown-item>
          <b-dropdown-item href="#" @click="searchStatusSelected('CLAIMING')">CLAIMING</b-dropdown-item>
          <b-dropdown-item href="#" @click="searchStatusSelected('CLAIMED')">CLAIMED</b-dropdown-item>
        </b-dropdown>
        </b-col>
      </b-row>
      <b-row>
        <b-col><label for="taxInvoice">Tax Invoice:</label></b-col>
        <b-col><input type="text" id="taxInvoice" placeholder="" v-model="filterObject.requestedTaxInvoice"></b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="filterTable()">
          Filter
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="filterModalShow = !filterModalShow">
          Close
        </b-btn>
      </div>
    </b-modal>

    <div class="row">
      <div class="col">
        <span> Rows Per Page:</span>
        <!-- <input v-model="rowsPerPageC" type="number"/> -->
        <b-dropdown id="ddown3" :text="rowsPerPageCText" class="m-md-1" :disabled="showLoadingAnimation">
          <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(150)">150</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(1000)">1000</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="col" align="center">
        <b-pagination
          size="sm"
          :total-rows="totalRowsC"
          v-model="currentPage"
          :per-page="rowsPerPageC"
          hide-ellipsis
          :limit="paginationButtonsLimit"
          align="center"
          @change="pageChanged"
          :disabled="disabledPagination"
          >
      </b-pagination>
      </div>
      <div class="col" align="right">
          <span>Total Rows {{totalRowsC}}</span>
        </div>
    </div>

    <br/>
    <button type="button" class="btn btn-primary" @click="refreshTable()" :disabled="showLoadingAnimation">Refresh</button>
    <b-btn @click="claimsCalculateModalShow = !claimsCalculateModalShow" :disabled="showLoadingAnimation">Calculate Claims</b-btn>
    <div class="claims-legend">
      <b>Claim Mode</b> shows whether one invoice was used alone or paired with another invoice.
      <b>Requested Qty</b> is the lens quantity used from the invoice selected by the customer.
      <b>Pairing Qty</b> is the lens quantity used from the second invoice in a paired claim.
      <b>Subtype</b> is the invoice item/subtype row id. <b>Lenses</b> is the quantity used from that row.
    </div>
    <b-table
      small
      bordered
      hover
      responsive
      striped
      show-empty
      class="claims-table"
      :items="tableRows"
      :fields="tableHeaders"
      @row-clicked="tableRowClicked">
      <template slot="cell(drawRecords)" slot-scope="data">
        <div class="draw-records-cell">{{data.value || '-'}}</div>
      </template>
    </b-table>

    <img src="static/img/Rolling.svg" alt="Loading data..."
      style="margin-left:auto; margin-right:auto; display: block;"
      v-if="showLoadingAnimation">
    <p style="text-align: center"
      v-if="showLoadingError">
    Loading error:
    </p>
    <p style="text-align: center"
      v-if="showNoResult">
    No Result
    </p>
x
    <!-- Modal Component -->
    <b-modal id="modal2" title="Calculate Claims" v-model="claimsCalculateModalShow">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><label for="campaignName">Campaign id:</label></b-col>
        <b-col><input type="text" id="campaignName" placeholder="" v-model="calculateClaimsObject.campaignDocId"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="email">Email:</label></b-col>
        <b-col><input type="text" id="email" placeholder="" v-model="calculateClaimsObject.claimEmail"></b-col>
      </b-row>
      <b-row>
        <b-col><label><b>Total Claimed Money: RM {{calculatedTotalClaimedPrizeMoney}}</b></label></b-col>
      </b-row>
      <b-row v-for="calculatedObject in calculatedObjects" v-bind:data="calculatedObject" v-bind:key="calculatedObject.id">
        <b-col><label>Email: {{calculatedObject.claimEmail}}</label></b-col>
        <b-col><label>Money Claimed: RM {{calculatedObject.prizeMoney}}</label></b-col>
        <b-col><label>Voucher / Other Rewards: {{calculatedObject.rewardSummary || '-'}}</label></b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-left" variant="primary" @click="calculateClaims()">
          Calculate
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="claimsCalculateModalShow = !claimsCalculateModalShow">
          Close
        </b-btn>
      </div>
    </b-modal>

  </div>
</template>

<script>
export default {
  data () {
    return {
      currentPage: this.$store.state.claimmod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null,
      filterModalShow: false,
      claimsCalculateModalShow: false,
      filterObject: {
        campaignDocId: '',
        claimEmail: '',
        prizeMoney: '',
        status: '',
        requestedTaxInvoice: '',
        hoyaAccountNumber: ''
      },
      calculateClaimsObject: {
        campaignDocId: '',
        claimEmail: ''
      }
    }
  },
  created: function () {
    this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' })
  },
  methods: {
    pageChanged: function (pageNumber) {
      this.currentPage = pageNumber
      console.log('User changed page to number: ' + this.currentPage)
      this.$store.commit('claimmod/changePageNumber', this.currentPage)
      this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' })
    },
    rowsPerPageSelected: function (rows) {
      console.log('rowsPerPageSelected, rows: ' + rows)
      let intRows = parseInt(rows)
      if (this.$store.state.claimmod.rowsPerPage !== intRows) {
        this.currentPage = 1
        this.$store.commit('claimmod/changePageNumber', this.currentPage)
        this.$store.commit('claimmod/setRowsPerPage', intRows)
        this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' })
      }
    },
    tableRowClicked: function (item, index, event) {
      console.log('Table row clicked')
      console.log('item: ' + item)
      this.$store.commit('claimmod/selectTableRow', item.docId)
      this.selectedRowItem = item
    },
    refreshTable: function () {
      this.currentPage = 1
      this.$store.commit('claimmod/changePageNumber', this.currentPage)
      this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' })
    },
    filterTable: function () {
      this.filterModalShow = false
      this.$store.dispatch('claimmod/filterTable', this.filterObject)
    },
    clearFilters: function () {
      let haveFilter = false
      for (let i in this.filterObject) {
        if (!this.filterObject[i] || this.filterObject[i] === '') {
          haveFilter = true
        }
        this.filterObject[i] = ''
      }
      if (!haveFilter) {
        return
      }
      this.currentPage = 1
      this.$store.commit('claimmod/changePageNumber', this.currentPage)
      this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' })
    },
    calculateClaims: function () {
      this.$store.dispatch('claimmod/calculateClaims', this.calculateClaimsObject)
    },
    searchStatusSelected: function (selectedStatus) {
      this.filterObject.status = selectedStatus
    }
  },
  computed: {
    disabledPagination: function () {
      return this.$store.state.claimmod.disabledPagination
    },
    tableRows: function () {
      return this.$store.state.claimmod.all
    },
    tableHeaders: function () {
      return this.$store.getters['claimmod/getHeaders']
    },
    totalRowsC: function () {
      return this.$store.state.claimmod.totalRows
    },
    rowsPerPageC: {
      get: function () {
        return this.$store.state.claimmod.rowsPerPage
      },
      set: function (newValue) {
        this.$store.commit('claimmod/setRowsPerPage', newValue)
      }
    },
    rowsPerPageCText: function () {
      return '' + this.$store.state.claimmod.rowsPerPage
    },
    calculatedObjects: function () {
      return this.$store.state.claimmod.calculatedObjects
    },
    calculatedTotalClaimedPrizeMoney: function () {
      return this.$store.state.claimmod.calculatedTotalClaimedPrizeMoney
    },
    showLoadingAnimation: function () {
      return this.$store.state.claimmod.showLoadingAnimation
    },
    showLoadingError: function () {
      return this.$store.state.claimmod.showLoadingError
    },
    showNoResult: function () {
      return this.$store.state.claimmod.showNoResult
    }
  },
  name: 'Claims'
}
</script>

<style scoped>
.claims-legend {
  background: #f7f9fc;
  border: 1px solid #d8e1ea;
  color: #34495e;
  font-size: 13px;
  line-height: 1.5;
  margin: 12px 0;
  padding: 10px 12px;
}

.claims-table /deep/ th,
.claims-table /deep/ td {
  white-space: nowrap;
  vertical-align: middle;
}

.claims-table /deep/ td[aria-colindex="12"],
.claims-table /deep/ td[aria-colindex="13"] {
  white-space: pre-line;
}

.draw-records-cell {
  max-height: 84px;
  width: 520px;
  max-width: 520px;
  overflow: auto;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/Claims.vue